// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"332":"5906e01d","354":"46e11525","418":"23dad0ff"}[chunkId] + ".js";
};